import {client} from '../helpers/api';

export async function getPaymentHistory(kId) {
  const kidIdQs = kId ? `?kid_id[]=${kId}` : '';

  const response = await client.get(`/api/payment-histories${kidIdQs}`);

  if (response.data?.status) {
    return (
      response.data?.data.map(
        ({
          transaction_id: id,
          _kid_id: kidId,
          _package_id: packageId,
          payment_type: type,
          payment_gateway_id: gatewayId,
          payment_txn_id: txnId,
          payment_image: image,
          payment_status: paymentStatus,
          date_created: date,
          notes,
          total_price: totalPrice,
          is_action_require: isActionRequire,
          invoice_url: invoiceUrl,
          payment_month: paymentMonth,
          payment_type: paymentType,
        }) => ({
          id,
          kidId,
          packageId,
          type,
          gatewayId,
          txnId,
          image,
          paymentStatus,
          date,
          notes,
          totalPrice,
          isActionRequire,
          invoiceUrl,
          paymentMonth,
          paymentType,
        }),
      ) || []
    );
  }
  throw response;
}

// {
// "transaction_id": "0027d078-2440-4542-9f36-0010ef001081",
// "_kid_id": "e6cfdf51-d611-4bbc-89b2-fd934d4a183e",
// "_package_id": "1082e459-9788-479a-9c59-5806457769eb",
// "payment_type": "manual",
// "payment_gateway_id": null,
// "payment_txn_id": null,
// "payment_image": null,
// "payment_status": "success",
// "approved_by": "3935d44b-0748-4ce5-bbfc-6be5f373e2f5",
// "notes": "good class payment",
// "date_created": "2021-01-14 22:35:2",
// "date_modified": "2021-01-14 23:04:51",
// "status": "active",
// "is_deleted": 0,
// "price_per_subject": null,
// "no_of_subject": null,
// "total_price": null
// },
